import { Controller } from "@hotwired/stimulus";

// Follows a catch-up run until it ends (QA AC-ACC-A19). Its progress is
// broadcast, but a run of a few documents ends before the page has
// subscribed to its stream, and the page stayed on « En cours · 0 sur 1 »:
// while the run is not finished, the card asks for its state itself. The
// answer replaces the card, which reconnects with the new state.
export default class extends Controller {
  static values = {
    url: String,
    finished: Boolean,
    interval: { type: Number, default: 3000 },
  };

  connect() {
    if (!this.finishedValue) {
      this.timer = setTimeout(() => this.refresh(), this.intervalValue);
    }
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  async refresh() {
    const response = await fetch(this.urlValue, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
      credentials: "same-origin",
    });
    if (response.ok) window.Turbo.renderStreamMessage(await response.text());
  }
}
